// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mQyF","footer":"styles_footer__7HFzi","passCodeTooltip":"styles_passCodeTooltip__x4meo"};